export default "__VITE_ASSET__6874d42c__"